var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4417 35L31.4708 42.0583L45.5583 27.9417",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3542 7.14585C33.3667 5.42502 36.6625 5.42502 38.7042 7.14585L43.3125 11.1125C44.1875 11.8708 45.8208 12.4833 46.9875 12.4833H51.9458C55.0375 12.4833 57.575 15.0208 57.575 18.1125V23.0708C57.575 24.2083 58.1875 25.8708 58.9458 26.7458L62.9125 31.3542C64.6333 33.3667 64.6333 36.6625 62.9125 38.7042L58.9458 43.3125C58.1875 44.1875 57.575 45.8209 57.575 46.9875V51.9459C57.575 55.0375 55.0375 57.575 51.9458 57.575H46.9875C45.85 57.575 44.1875 58.1875 43.3125 58.9458L38.7042 62.9125C36.6917 64.6334 33.3958 64.6334 31.3542 62.9125L26.7458 58.9458C25.8708 58.1875 24.2375 57.575 23.0708 57.575H18.025C14.9333 57.575 12.3958 55.0375 12.3958 51.9459V46.9584C12.3958 45.8209 11.7833 44.1875 11.0542 43.3125L7.11665 38.675C5.42498 36.6625 5.42498 33.3959 7.11665 31.3834L11.0542 26.7458C11.7833 25.8708 12.3958 24.2375 12.3958 23.1V18.0833C12.3958 14.9917 14.9333 12.4542 18.025 12.4542H23.0708C24.2083 12.4542 25.8708 11.8417 26.7458 11.0833L31.3542 7.14585Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/verify.d0aa29b09e793588a633d077976f92f8.svg";
export { ForwardRef as ReactComponent };